import { HttpService } from '@/services/http.ts'
import { DashboardFilters } from '@/services/dashboard-filters.ts'
import type { RoleDefaultScope } from '@/services/models.ts'

/** The current role's sign-in scope: the branch / RM scope applied every time the user signs in to this bank. */
export class RoleApi {
  private static headers(): Record<string, string> {
    return { Role: DashboardFilters.getCurrentRole().id }
  }

  /** Replace the sign-in scope (empty lists = every account). Returns it in canonical form. */
  static async setDefaultScope(scope: RoleDefaultScope): Promise<RoleDefaultScope> {
    return HttpService.put('/role/scope/', scope, this.headers())
  }

  static async clearDefaultScope(): Promise<RoleDefaultScope> {
    return HttpService.delete('/role/scope/', this.headers())
  }
}
